import { services } from '../data/mock';

export default function Services() {
  return (
    <section
      id="services"
      className="relative px-5 md:px-10 lg:px-14 py-24 md:py-32 border-t border-white/10"
      data-testid="services-section"
    >
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-4">
          <p className="text-[10px] md:text-[11px] tracking-[0.3em] text-[#FF3D2E] mb-6">
            — WHAT WE DO
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-white">
            We build brand ecosystems designed to move culture, create demand, and convert attention into growth.
          </h2>
          <p className="mt-8 text-white/70 text-base md:text-lg leading-relaxed">
            SMG is not a traditional marketing agency. We build the connective tissue between brand, product, culture, and revenue — so every campaign moves the business, not just the timeline.
          </p>
        </div>

        <ul className="lg:col-span-8 grid sm:grid-cols-2 gap-x-10 gap-y-8">
          {services.map((s, i) => (
            <li
              key={s.title}
              className="border-t border-white/10 pt-5 group"
              data-testid={`service-${i}`}
            >
              <div className="flex items-start gap-4">
                <span className="font-display text-2xl text-white/30 shrink-0 leading-none pt-1 group-hover:text-white/70 transition-colors">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div>
                  <h3 className="text-white text-base md:text-lg font-medium tracking-tight mb-1.5">
                    {s.title}
                  </h3>
                  <p className="text-white/60 text-[13.5px] leading-relaxed">{s.desc}</p>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
